var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.SpecialityModal, {
    attrs: {
      value: _setup.isDialogOpened,
      "is-back": "",
      title: _setup.t("Доп. специальность", _setup.options),
      placeholder: _setup.t("Специальность", _setup.options),
      "title-truncate": "",
      "is-visible-reset": "",
      "town-id": _setup.commonStore.town.id,
      "town-translit": _setup.commonStore.town.translit,
      "is-doctor-list-home":
        _setup.filtersStore.filters.visitLocation === "home",
      "is-doctor-list-online":
        _setup.filtersStore.filters.visitLocation === "online",
      "selected-speciality": _setup.filtersStore.unsavedFilters.otherSpeciality,
      "excluded-speciality": _setup.filtersStore.filters.speciality,
    },
    on: {
      "speciality:selected": _setup.onClickSpeciality,
      "speciality:reset": _setup.onReset,
      input: _setup.handleCloseModal,
    },
    scopedSlots: _vm._u([
      {
        key: "footer",
        fn: function () {
          return [
            _c(_setup.BtnShowDoctors, {
              staticClass: "pa-2 elevation-8",
              attrs: { active: _setup.isDialogOpened },
              on: {
                "click:submit": _setup.applySelectedPlace,
                "click:close": _setup.closeDialog,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }